// Product page reviews: fills the rating bars when the section scrolls into view.
const section = document.querySelector('.pdp-reviews');
if (section && 'IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
  section.setAttribute('data-rv-animate', '');
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      section.setAttribute('data-rv-visible', '');
      observer.disconnect();
    }
  }, { threshold: 0.25 });
  observer.observe(section);
}

// Write a review form: on desktop it is lifted out of the narrow rating card so it can show as a
// full-width card above both columns; the section is flagged while the form is open.
if (section) {
  const sync = () => {
    const widget = section.querySelector('.jdgm-rev-widg');
    const form = section.querySelector('.jdgm-form-wrapper');
    if (!widget || !form) return;
    if (form.parentElement !== widget) widget.prepend(form);
    const open = getComputedStyle(form).display !== 'none' && form.offsetHeight > 0;
    const wasOpen = section.hasAttribute('data-rv-form-open');
    section.toggleAttribute('data-rv-form-open', open);
    if (open && !wasOpen && matchMedia('(min-width: 768px)').matches) {
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };
  new MutationObserver(sync).observe(section, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
  sync();
}

